@if (hasAppointments()) {
  <div class="w-full bg-gray-700 bg-opacity-80 p-1 rounded-t relative z-20">
    <div class="flex space-x-2 overflow-x-auto" [class.hidden]="isMinimised$()">
      @for (appt of service.appts$(); track appt) {
        <div
          [class.hover:bg-opacity-80]="appt.appointment.appointmentType === AppointmentType.Video || appt.appointment.appointmentType === AppointmentType.Audio"
          class="flex items-center bg-gray-800 text-white text-sm rounded-full p-1 space-x-2 cursor-pointer transition"
          (click)="joinAppointment(appt)">
          <!-- Join button -->
          <button
            aria-label="Join"
            class="flex-none p-2 bg-blue-850 rounded-full">
            <app-icon icon="{{ getAppointmentTypeIcon(appt.appointment.appointmentType) }}" fontSize="22px" lineHeight="22px"></app-icon>
          </button>
          <!-- Title + time -->
          <div class="flex-1 min-w-0">
            <div class="font-medium truncate">{{ appt.appointment.title }}</div>
            <div class="flex text-xs items-center text-gray-300">
              <app-icon icon="mdi-clock-outline" lineHeight="14px" fontSize="14px"></app-icon>
              <span>{{ appt.appointment.startTime | localizedDate:'HH:mm aa' }}</span>
            </div>
          </div>
          <!-- Participant avatars -->
          <div class="flex -space-x-1 flex-none">
            @for (part of appt.participants; track part) {
              @if (part.userId !== authUserId) {
                <div
                  class="w-8 h-8 bg-gray-950 rounded-full flex items-center justify-center text-xs"
                  [tooltip]="part.firstName + ' ' + part.lastName"
                containerClass="fitmed-tooltip">{{ getInitials(part) }}</div>
              }
            }
          </div>
        </div>
      }
    </div>
    <div class="absolute right-2 top-[-35px]">
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/80 px-2.5 py-1 text-slate-100 shadow-lg shadow-slate-950/25 transition hover:border-blue-500/30 hover:bg-slate-900"
        (click)="toggleMinimised()"
        [attr.aria-label]="getToggleLabel()">
        @if (isMinimised$()) {
          <app-icon icon="mdi-arrow-collapse-up"></app-icon>
        }
        @if (!isMinimised$()) {
          <app-icon icon="mdi-arrow-collapse-down"></app-icon>
        }
        <span
          class="inline-flex min-h-5 min-w-5 items-center justify-center rounded-full border border-blue-400/30 bg-blue-500/10 px-1 text-[11px] font-bold leading-none text-blue-200 ring-1 ring-slate-950/70">
          {{ appointmentCount() > 99 ? '99+' : appointmentCount() }}
        </span>
      </button>
    </div>
  </div>
}
